import React from 'react';
import { MailboxReportsSC, TableSC } from './mailbox-reports.styled';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../../redux/action';
import { Pagination } from '../../ui';
import useInlinePagination from '../../../utils/hooks/useInlinePagination';
import Button from '../../ui/button';
import { BodyText, SmallText } from '../../typography';
import Moment from 'react-moment';
import { BP_TABLET_MIN } from '../../../assets/styles/breakpoints';
import useWindowSize from '../../../utils/screen-size';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import ReportDetail from './components/report-detail';
import ReportsSubscribe from './components/reports-subscribe';
import { EmptySC } from '../investor-mailbox-content.styled';
import InlineLoading from '../../ui/inline-loading';
import { FormattedHTMLMessage } from 'react-intl';

const MailboxReports = ({ reports, getMailboxReports, loading }) => {
  const [selectedDetail, setSelectedDetail] = React.useState(null);

  React.useEffect(() => {
    getMailboxReports();
  }, [getMailboxReports]);

  const {
    slicedData,
    paginationConfig,
    onChange: handlePaginationChange,
    onPageSizeChange,
  } = useInlinePagination(reports);

  const screenSize = useWindowSize();
  const isTablet = screenSize.width < BP_TABLET_MIN;

  return (
    <>
      <ReportsSubscribe />
      {slicedData.length > 0 ? (
        <MailboxReportsSC>
          <TableSC>
            <tbody>
              {slicedData.map((message) => (
                <tr key={message.id}>
                  <td>
                    <div className="top-wrap">
                      <span>{message.subject ? message.subject : ''}</span>
                      <BodyText className="black-transparent-lighter">
                        <Moment format="DD. MMMM YYYY">{message.created_at}</Moment>
                      </BodyText>
                      {isTablet ? (
                        <BodyText className="black-transparent-lighter italic">
                          <FormattedMessage
                            id="mailbox_reports_sent_through"
                            defaultMessage={dlt['mailbox_reports_sent_through']}
                          />{' '}
                          "{message.type === 'sms' ? 'SMS' : 'Email'}"
                        </BodyText>
                      ) : null}
                    </div>
                    <div className="body-wrap">
                      <BodyText className="black-transparent">
                        <FormattedHTMLMessage
                          id="mailbox_short_message"
                          defaultMessage={message.short_message}
                        />
                      </BodyText>
                      {isTablet ? null : (
                        <BodyText className="black-transparent-lighter italic">
                          <FormattedMessage
                            id="mailbox_reports_sent_through"
                            defaultMessage={dlt['mailbox_reports_sent_through']}
                          />{' '}
                          "{message.type === 'sms' ? 'SMS' : 'Email'}"
                        </BodyText>
                      )}
                    </div>
                    {isTablet ? (
                      <div className="actions-wrap">
                        <div className="actions-wrap--item">
                          <BodyText className="bolder">
                            <FormattedMessage
                              id="mailbox_reports_sender"
                              defaultMessage={dlt['mailbox_reports_sender']}
                            />
                          </BodyText>
                          <br />
                          <BodyText>{message.sender}</BodyText>
                        </div>
                        <Button type="LINK" onClick={() => setSelectedDetail(message)}>
                          <FormattedMessage
                            id="mailbox_table_detail_and_documents"
                            defaultMessage={dlt['mailbox_table_detail_and_documents']}
                          />
                        </Button>
                      </div>
                    ) : null}
                  </td>
                  {isTablet ? null : (
                    <td>
                      <div className="actions-wrap">
                        <div className="actions-wrap--item">
                          <BodyText className="bolder">
                            <FormattedMessage
                              id="mailbox_reports_sender"
                              defaultMessage={dlt['mailbox_reports_sender']}
                            />
                          </BodyText>
                          <br />
                          <BodyText>{message.sender}</BodyText>
                        </div>
                        <Button type="LINK" onClick={() => setSelectedDetail(message)}>
                          <FormattedMessage
                            id="mailbox_reports_detail_and_documents"
                            defaultMessage={dlt['mailbox_reports_detail_and_documents']}
                          />
                        </Button>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </TableSC>
          {reports.length > 0 && (
            <div className="pagination-wrap">
              <Pagination
                pagination={paginationConfig}
                onChange={handlePaginationChange}
                onPageSizeChange={onPageSizeChange}
              />
            </div>
          )}
        </MailboxReportsSC>
      ) : (
        <EmptySC>
          <div className="empty-table">
            {loading ? (
              <InlineLoading />
            ) : (
              <SmallText className="black-transparent bold">
                <FormattedMessage
                  id="mailbox_reports_empty"
                  defaultMessage={dlt['mailbox_reports_empty']}
                />
              </SmallText>
            )}
          </div>
        </EmptySC>
      )}
      <ReportDetail detail={selectedDetail} onClose={setSelectedDetail} />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    reports: state.mailbox.reports,
    loading: state.mailbox.reportsLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getMailboxReports: ActionCreators.getMailboxReports,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(MailboxReports));
